import moment from 'moment';

export default {
    getCurrentMonth() {
        return moment().format('MMMM');
    },

    formatDate(date) {
        return moment(date).format('YYYY-MM-DD')
    },

    getGraphDate(day) {
        return moment().format(`YYYY-MM-${day}`);
    },

    getCurrentDate() {
        return moment().format('YYYY MMMM DDDD');
    },

    getDateToday() {
        return moment().format('YYYY-MM-DD');
    },

    getDateYesterday() {
        return moment().subtract(1, 'days').format('YYYY-MM-DD');
    },

    getStartWeek() {
        return moment().startOf('week').add(1, 'days').format('YYYY-MM-DD');
    },

    getStartLastWeek() {
        return moment().subtract(1, 'weeks').startOf('week').add(1, 'days').format('YYYY-MM-DD');
    },

    getDateThisMonth() {
        return moment().startOf('month').format('YYYY-MM-DD');
    },
    
    getLastMonthStart() {
        return moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
    },

    getLastWeekEnd() {
        return moment().subtract(1, 'weeks').endOf('week').add(1, 'days').format('YYYY-MM-DD');
    },

    getLastYearEnd() {
        return moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD');
    },

    getFirstDayCurrentMonth() {
        return moment().startOf('month').format('YYYY-MM-DD');
    },

    getLastDayCurrentMonth() {
        return moment().endOf('month').format('DD');
    },

    getDayCurrentMonth() {
        return moment().format('DD');
    },

    getFirstDayYear() {
        return moment().startOf('year').format('YYYY-MM-DD');
    },

    getFirstDayLastYear() {
        return moment().subtract(1, 'year').startOf('year').format('YYYY-MM-DD');
    },
    
    getCurrentMonthStart() {
        return moment().startOf('month').format('YYYY-MM-DD');
    },

    getLastMonthEnd() {
        return moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
    },

    getMonthEnd() {
        return moment().endOf('month').format('YYYY-MM-DD');
    },

    getCurrentYear() {
        return moment().format('YYYY');
    },

    getCurrentDay() {
       // Get current day
       return moment().format('YYYY-MM-DD h:mm:ss');
    },

    convertToLocalTime(date, time) {
        return moment.utc(date + ' ' + time).local().format('YYYY-MM-DD HH:mm:ss')
    }
};
